<template>
	<LoginLayout
		heading="Reset your password"
	>
		<template #form>
			<div
				v-if="emailLinkSent"
				class="text-center"
			>
				<div class="login-icon-roundel mb-6">
					<v-icon size="32">
						mdi-email-check-outline
					</v-icon>
				</div>
				<p class="login-info-text">
					If the email you have supplied exists then we will send an email to that address with a link that allows you to reset your password.
				</p>
			</div>
			<validation-observer
				v-else
				#default="{ handleSubmit }"
				class="cassie-vertical-md"
			>
				<TextField
					v-model="username"
					label="Username *"
					rules="required"
				/>
				<TextField
					v-model="email"
					label="Email Address *"
					rules="required|email"
				/>
				<v-card-actions class="pa-0">
					<v-row>
						<v-col cols="12">
							<v-btn
								block
								color="primary"
								class="sign-in-button text-none"
								@click="handleSubmit(restorePassword)"
							>
								Submit
							</v-btn>
						</v-col>
						<v-col
							cols="12"
							class="text-center"
						>
							<TextButton @click="$router.push('/login')">
								Cancel
							</TextButton>
						</v-col>
					</v-row>
				</v-card-actions>
			</validation-observer>
		</template>
	</LoginLayout>
</template>

<script>
import LoginLayout from '../../../../../shared/layouts/login-layout.vue'
import TextButton from '../../../../../shared/components/text-button.vue'
import { sendResetPasswordEmailApi } from '../../../../../shared/utils/api/forgotten-password.js'
import TextField from '../../../../../shared/components/text-field.vue'

export default {
	components: { TextField, LoginLayout, TextButton },
	data () {
		return {
			username: '',
			email: '',
			emailLinkSent: false
		}
	},
	methods: {
		async restorePassword () {
			const { username, email } = this

			try {
				await sendResetPasswordEmailApi({ username, email })
				this.emailLinkSent = true
			} catch (error) {
				if (error.response && error.response.status === 403) {
					this.$router.push({ name: 'direct-login-not-allowed' })
				}
			}
		}
	}
}
</script>
